import { render, staticRenderFns } from "./interpage.vue?vue&type=template&id=2a79fe22"
import script from "./interpage.vue?vue&type=script&lang=js"
export * from "./interpage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports